window.addEventListener("load", (event) => {
    const fontPicker = document.querySelector('#font-picker');
    const fontFamily = document.querySelector('#font-family');

    if (fontPicker){
        new FontPicker(
            'AIzaSyCSBNK_7e0dYTRKndL8IMWER1DAKIPOHtw',
            fontFamily.value === '' ? 'Open Sans' : fontFamily.value,
            {
                limit: 100,
                variants: ["regular", "italic"],
                sort: "popularity"
            },
            function (font) {
                fontFamily.value = font.family;
            }
        );
    }
});
